class MenuMobile {
    constructor() {
        this.burgerIcon = document.querySelector('.burger-icon');
        this.menu = document.querySelector('.nav-main');
        this.burgerIcon.addEventListener('click', this.toggleMenu.bind(this));
        this.lev1Items = document.querySelectorAll(".menu-item-has-children");
        this.lev1Items.forEach(item => {
            const link = item.querySelector(":scope > a");
            link.addEventListener('click', this.showLevel2.bind(this));
        });
    }

    toggleMenu() {
        this.burgerIcon.classList.toggle('burger-icon__open');
        this.menu.classList.toggle('nav-main__open');
    }

    showLevel2(event) {
        // déplie le niveau 2 au clic en mobile uniquement
        if (window.innerWidth < 1100) {
            const current = event.target.closest(".menu-item-has-children").querySelector('.menu-lev2');
            const alreadyOpen = current.classList.contains("show");
            event.preventDefault();
            this.lev1Items.forEach(other => {
                other.querySelector(".menu-lev2").classList.remove("show");
            });
            if (!alreadyOpen) {
                current.classList.add('show');
            }
        }
    }
}